import { createMigrate } from "redux-persist";

const LEGACY_ZUSTAND_KEY = "auth-storage";
const LEGACY_AUTH_USER_KEY = "authUser";

function parseJson(raw) {
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function readLegacyAuth() {
  const zustandRaw = localStorage.getItem(LEGACY_ZUSTAND_KEY);
  const zustand = parseJson(zustandRaw);
  const zustandState = zustand?.state ?? zustand;

  const authUser = parseJson(localStorage.getItem(LEGACY_AUTH_USER_KEY));

  const accessToken = zustandState?.accessToken ?? null;
  const user = authUser ?? null;
  const role = user?.role ?? zustandState?.role ?? null;
  const hasCompletedOnBoarding = Boolean(
    user?.hasCompletedOnBoarding ?? zustandState?.hasCompletedOnBoarding
  );
  const agreementLink = user?.agreementLink ?? null;

  const hasLegacy = accessToken || user || role || agreementLink;

  if (!hasLegacy) return null;

  return {
    auth: {
      accessToken,
      user,
      role,
      hasCompletedOnBoarding,
    },
    common: {
      agreementLink,
    },
  };
}

function clearLegacyAuthKeys() {
  try {
    localStorage.removeItem(LEGACY_ZUSTAND_KEY);
    localStorage.removeItem(LEGACY_AUTH_USER_KEY);
  } catch {
    // ignore
  }
}

const migrations = {
  1: (state) => {
    if (state?.auth?.accessToken || state?.auth?.user) {
      return state;
    }

    const legacy = readLegacyAuth();
    if (!legacy) {
      return state;
    }

    clearLegacyAuthKeys();

    return {
      ...state,
      auth: legacy.auth,
      common: {
        ...state?.common,
        ...legacy.common,
      },
    };
  },
};

export const persistMigrate = createMigrate(migrations, { debug: false });
export const PERSIST_VERSION = 1;
